var _style, _g, _title, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 260 210",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0 {\n      fill: #ffffff;\n    }\n    .st1 {\n      fill: #4c4c4c;\n    }\n    .st2 {\n      fill: url(#SVGID_1_);\n    }\n    .st3 {\n      opacity: 0.87;\n      fill: #4c4c4c;\n    }\n    .st4 {\n      fill: url(#SVGID_2_);\n    }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 212,
    width: 262,
    y: -1,
    x: -1
  }))), /*#__PURE__*/React.createElement("g", null, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m8.799993,172.8l-1.9,0c-3.1,0 -4.4,-1.2 -4.4,-3.6c0,-2.4 1.3,-3.6 4.4,-3.6l1.9,0l0,-6.7c0,-3.6 2.2,-5.5 5.5,-5.5s5.5,1.9 5.5,5.5l0,6.7l3.3,0c3.2,0 5,1 5,3.6s-1.7,3.6 -5,3.6l-3.3,0l0,22c0,1.7 0.9,2.6 2.9,2.6l1.6,0c2.4,0 3.8,1.4 3.8,3.7c0,3.2 -2.7,4.9 -8,4.9c-8,0 -11.3,-3.3 -11.3,-9.8l0,-23.4z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    d: "m77.799993,200.4c0,3.3 -1.5,5.5 -5,5.5c-3.5,0 -5,-2.2 -5,-5.5l0,-1.4l-0.2,0c-3.1,4.1 -7.1,6.9 -13.3,6.9c-6.6,0 -13.8,-3.3 -13.8,-14.4l0,-21.5c0,-2.9 1.2,-5.5 5.5,-5.5s5.5,2.6 5.5,5.5l0,19.2c0,4.4 2.2,7.6 6.9,7.6c3.8,0 8.4,-3.2 8.4,-8.7l0,-18.1c0,-2.9 1.2,-5.5 5.5,-5.5c4.3,0 5.5,2.6 5.5,5.5l0,30.4z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    d: "m108.799993,164.6c8.4,0 16.8,3.3 16.8,8.4c0,2.6 -1.7,4.8 -4.6,4.8c-4.3,0 -4.4,-5 -11.4,-5c-3.8,0 -6.3,1.1 -6.3,3.4c0,2.6 2.5,3.2 5.9,3.9l4.6,1.1c6.2,1.4 13.7,4.1 13.7,11.7c0,9 -8.7,13.1 -16.9,13.1c-9.9,0 -18.2,-4.4 -18.2,-9.9c0,-2.4 1.4,-4.6 4.4,-4.6c4.7,0 5.2,6.8 13.3,6.8c3.9,0 6.4,-1.7 6.4,-4c0,-2.8 -2.4,-3.2 -6.3,-4.2l-6.5,-1.6c-6.4,-1.6 -11.4,-4.2 -11.4,-11.6c0,-9 8.9,-12.3 16.5,-12.3z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    d: "m141.899993,155.2c0,-3.6 2.2,-5.5 5.5,-5.5c3.3,0 5.5,1.9 5.5,5.5l0,25l12.2,-13.5c1.1,-1.2 2.6,-2.1 4.2,-2.1c2.5,0 5.2,2.2 5.2,5c0,2 -0.7,2.6 -1.7,3.6l-8.1,8.5l11.4,15.3c0.4,0.5 1.1,1.7 1.1,3.5c0,2.8 -2.3,5.3 -5.2,5.3c-2.7,0 -4.1,-1.4 -5,-2.6l-10.4,-14.7l-3.8,3.4l0,8.4c0,3.6 -2.2,5.5 -5.5,5.5c-3.3,0 -5.5,-1.9 -5.5,-5.5l0,-45.1l0.1,0z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    d: "m190.499993,155.2c0,-3.6 2.2,-5.5 5.5,-5.5s5.5,1.9 5.5,5.5l0,45.1c0,3.6 -2.2,5.5 -5.5,5.5s-5.5,-1.9 -5.5,-5.5l0,-45.1z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    d: "m227.699993,187.3c0,5.8 3.8,10 10.2,10c8.3,0 8.3,-5.4 12.7,-5.4c2.6,0 4.5,2.3 4.5,4.3c0,6.6 -10.6,9.7 -17.2,9.7c-15.4,0 -21.1,-10.4 -21.1,-19.9c0,-12.8 7.8,-21.4 20.8,-21.4c12.6,0 19.9,9 19.9,18c0,3.8 -1.1,4.7 -4.8,4.7l-25,0zm19.2,-6.3c-0.6,-5 -4.4,-8.7 -9.3,-8.7c-5.5,0 -8.8,3.4 -10,8.7l19.3,0z",
    className: "st1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 134,
    y1: -133,
    x2: 127,
    y2: 206
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00EFA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F56F0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    d: "m236.146368,56.642019c-0.1,-5.3 -0.7,-10.1 -1.8,-14.5c-6.6,-27.3 -23.6,-31 -26.3,-30c-4.2,1.5 5.6,12.8 5.4,31.4c-0.2,24 -16,43.5 -35.6,43.5c-0.4,0 -0.9,0 -1.3,0c0,-0.5 0,-1 0,-1.5c0.8,-47.5 -29.2,-67.5 -62.6,-71.5c-3.2,-0.4 -6.4,-0.6 -9.6,-0.6c-0.5,0 -1.1,0 -1.6,0c-43.7,0.8 -78.9,36.6 -78.9,80.5c0,14.5 3.9,28.2 10.6,39.9c3.2,5.5 9.2,5.5 9.2,5.5l22.7,0c0,0 4.7,0.4 3.7,-4.3c-0.3,-1.7 -0.2,-3.6 0.1,-5.5c1.4,-8 8.2,-14.3 16.3,-15c10.8,-0.9 19.9,7.6 19.9,18.2c0,1.1 -0.2,2.2 -0.3,3.2c-0.4,3.7 3.7,3.4 3.7,3.4l26.2,0c0,0 3.6,0 4.5,-3.4c1.7,-6.2 3,-12.6 3.7,-19.2c0.3,-2.5 0.6,-6 3.7,-0.1c13,24.4 39.6,21.2 50.8,18.8c5.1,-1.1 4.6,-5.8 4.6,-5.8l-0.2,-2.4c0,0 -0.5,-3 -5.4,-1.9c-9.6,2.1 -15.1,-2 -18.1,-8.4l0,0c31.7,-2.1 57.1,-28.3 56.6,-60.3zm-84.5,-11.4c2.9,0 5.2,2.3 5.2,5.2s-2.3,5.2 -5.2,5.2c-2.9,0 -5.2,-2.3 -5.2,-5.2s2.3,-5.2 5.2,-5.2zm25.7,64.4c-0.5,0 -1,0 -1.4,0c-11.6,0 -22.3,-3.7 -31.1,-10.1c-0.9,-0.7 -1.8,-1.4 -2.7,-2.1c-6.5,-5.4 -11.8,-12.3 -15.1,-20.3l0,0c0.8,-2.6 2.5,-4.9 5,-6.6c2.7,-1.8 5.8,-2.4 8.7,-1.9l0,0c4.5,9.2 11.3,16.6 19.5,21c4.9,2.6 10.2,4.2 15.8,4.5c0,0.5 0,0.9 0,1.4c0.1,-0.5 0.1,-0.9 0.1,-1.4c0.6,0 1.2,0 1.8,0c23.7,0 43.2,-22.8 42.9,-50.8c-0.1,-9.8 -4.9,-18.2 -3.3,-19.4c1.3,-1 6.7,7.2 9.4,16.4c1.3,4.5 1.9,11.2 1.9,16.2c0,28.9 -22.9,52.3 -51.5,53.1z",
    className: "st2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d05ea40375ce5260459442834e83da93.svg";
export { ForwardRef as ReactComponent };